import type { EAverageType } from '@web/entities/measurement/model/enums/average-type.enum.ts'
import type { EDetectorType } from '@web/entities/measurement/model/enums/detector-type.enum.ts'

export const mapAverageType: { [key in EAverageType]: string } = {
  LINEAR: 'Линейное',
  EXPONENTIAL: 'Экспоненциальное'
}

export const averageTypeOptions = Object.entries(mapAverageType).map(
  ([key, label]) => ({
    value: key as EDetectorType,
    label
  })
)
